import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from "react-router-dom";
import { Box } from 'grommet/components/Box';
/*import { Heading } from 'grommet/components/Heading';*/
import Header from '../Components/Header.js';
import Footer from '../Components/Footer.js';
import { Link } from 'react-router-dom';
import { isLandingAlertVisible, dismissLandingAlert } from '../Utils/Utility';

const REGISTRATION_SELECT_LANDING_ALERT_STORAGE_KEY = 'dismissedRegistrationSelectLandingAlert';

class RegistrationSelect extends Component {

    static propTypes = {
        match: PropTypes.object.isRequired,
        location: PropTypes.object.isRequired,
        history: PropTypes.object.isRequired
    }
    constructor(props) {
        super(props);
        this.state = {
            code: '',
            showLandingAlert: isLandingAlertVisible(REGISTRATION_SELECT_LANDING_ALERT_STORAGE_KEY)
        }
        this.setCode = this.setCode.bind(this);
        this.dismissLandingAlert = this.dismissLandingAlert.bind(this);

    }

    setCode(param) {
        if (param === '/SocietyRegistration') {
            this.setState({
                code: 'society'
            })
        } else {
            this.setState({
                code: 'shop'
            })
        }
    }

    dismissLandingAlert() {
        this.setState({ showLandingAlert: false });
        dismissLandingAlert(REGISTRATION_SELECT_LANDING_ALERT_STORAGE_KEY);
    }


    render() {
        return (
            <Box>

                <Header />

                {this.state.showLandingAlert ? (
                    <div role="dialog" aria-modal="true" aria-labelledby="cookiesDialogTitle" style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.4)', zIndex: 1000, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '16px' }}>
                        <div style={{ background: '#ffffff', width: '100%', maxWidth: 560, borderRadius: 4, boxShadow: '0 8px 24px rgba(0,0,0,0.2)', overflow: 'hidden', fontFamily: "Open Sans,Helvetica Neue,Helvetica,Arial,sans-serif" }}>
                            <div id="cookiesDialogTitle" style={{ background: '#006FCF', color: '#fff', fontWeight: 600, padding: '10px 16px', textAlign: 'center' }}>
                                Cookies di American Express
                            </div>
                            <div style={{ padding: '16px 16px 8px 16px', color: '#1b1b1b', lineHeight: 1.5, fontSize: 16 }}>
                                American Express utilizza i cookie su questo sito web per garantirne il corretto funzionamento e la massima sicurezza e per fornire agli utenti i servizi richiesti (cookie essenziali). Per ulteriori informazioni sull'utilizzo dei cookie puo' consultare in qualsiasi momento la nostra
                                <a href="https://www.americanexpress.com/content/dam/amex/it/merchant/AXPNexiCookiesPolicyfinal.pdf" target="_blank" rel="noopener noreferrer" style={{ color: '#006FCF', textDecoration: 'underline', fontWeight: 600 }}>
                                    &quot;Cookie policy&quot;
                                </a>
                                .
                            </div>

                            <div style={{ padding: '0 16px 20px 16px', display: 'flex', justifyContent: 'center' }}>
                                <button onClick={this.dismissLandingAlert} style={{ background: '#006FCF', color: '#fff', border: 'none', borderRadius: 2, padding: '10px 24px', cursor: 'pointer', fontWeight: 600 }}>
                                    Chiudi
                                </button>
                            </div>
                        </div>
                    </div>
                ) : ''}


                <Box direction="column" align='center' className='background-color registration-form-select'>

                    <h1 level='1' className='fixFont' style={{ margin: '0 0 40px 0' }}>
                        Registrazione
                    </h1>
                    <h3 level='2' className='fixFont' margin='0'>
                        Sono un/a
                        </h3>

                    <Box id='icons' direction='row' gap='large'>

                        <Link exact to={{ pathname: '/ShopRegistration', step: 1 }} style={{ textDecoration: 'none' }} onMouseOver={() => this.setCode('/ShopRegistration')}>
                            <Box direction='column' className='icon-border' justify='center'>

                                <Box>
                                    <i className='icon-shop icon'></i>
                                </Box>
                                <Box className='icontext'>
                                    Punto Vendita
                                    </Box>

                            </Box>
                        </Link>

                        <Link exact to={{ pathname: '/SocietyRegistration', step: 1 }} style={{ textDecoration: 'none' }} onMouseOver={() => this.setCode('/SocietyRegistration')}>
                            <Box direction='column' className='icon-border' justify='center'>

                                <Box>
                                    <i className='icon-company icon'></i>
                                </Box>
                                <Box className='icontext'>
                                    Società
                                    </Box>

                            </Box>
                        </Link>

                    </Box>

                    <span>Sei già registrato? <Link to='/login' style={{ color: '#006fcf', textDecoration: 'none' }}>Accedi</Link></span>
                </Box>


                <Footer />

            </Box>

        )
    }

}

export default RegistrationSelect = withRouter(RegistrationSelect)
